import Login from '../feature/login/login'
import LoginRestrito from '../feature/login-restrito/login-restrito'
import fornecedorForm from '../feature/fornecedor/fornecedor-form'
import fornecedorExtrato from '../feature/fornecedor/extrato/fornecedor-extrato'
import Cadastrador from '../feature/cadastrador/cadastrador'
import AreaRestrita from '../feature/area-restrita/area-restrita'
import SolicitacaoFornecedor from '../feature/area-restrita/fornecedor/solicitacao-fornecedor'
import VeracidadeFornecedor from '../feature/area-restrita/fornecedor/veracidade-fornecedor'
import ConsultarFornecedor from '../feature/area-restrita/fornecedor/consultar-fornecedor'
import ResumoHabilitador from '../feature/area-restrita/fornecedor/resumo-habilitador'
import Dashboard from '../feature/area-restrita/fornecedor/dashboard'
import FornecedorDetalhe from '../feature/area-restrita/fornecedor/fornecedor-detalhe'

import fornecedorPainel from '../feature/fornecedor/fornecedor-painel'
import DocumentosVencidos from '../feature/fornecedor/documentos-vencidos'
import solicitacaoLista from '../feature/fornecedor/solicitacaoLista'
import fornecedorResumo from '../feature/fornecedor/resumo/fornecedor-resumo'
import ConsultaCadastroFornecedor from '../feature/area-restrita/fornecedor/consulta-cadastro'
import DuplaConferenciaFornecedor from '../feature/area-restrita/fornecedor/dupla-conferencia'
import TermoDeclaracaoConcordancia from '../feature/fornecedor/termo-declaracao-concordancia'
import indeferimentoResumo from '../feature/fornecedor/resumo/indeferimento-resumo'

import GuiasOrientacoes from '../feature/area-restrita/fornecedor/guias-orientacoes'
import GestaoAcesso from '../feature/area-restrita/fornecedor/gestao-acesso' 

import Relatorios from '../feature/area-restrita/fornecedor/relatorios'
import CadastrarNovo from '../feature/cadastrador/cadastrarnovo'

export default
 [
     //Fornecedor
    { path: '/', component: Login },
    { path: '/login', component: Login },
    { path: '/loginrestrito', component: LoginRestrito },
    { path: '/cadastro', component: fornecedorForm },
    { path: '/cadastro/:alterar', component: fornecedorForm },
    { path: '/cadastro/:alterar/:id', component: fornecedorForm },

    { path: '/extrato', component: fornecedorExtrato },

    { path: '/resumo-solicitacao/:id', component: fornecedorResumo },

    { path: '/fornecedor-painel', component: fornecedorPainel },

    { path: '/historico-solicitacoes', component: solicitacaoLista },

    { path: '/documentos-vencidos', component: DocumentosVencidos },

    { path: '/indeferimento-resumo/:id', component: indeferimentoResumo },

    { path: '/termo-declaracao-concordancia/:id/:config', component: TermoDeclaracaoConcordancia },

    { path: '/guias-orientacoes', component: GuiasOrientacoes },
    
    { path: '/gestao-acesso', component: GestaoAcesso }, // ← Nova rota


    //Area Restrita

    //Solicitacao
    { path: '/arearestrita', component: AreaRestrita },
    { path: '/arearestrita/habilitador/solicitacao', component: SolicitacaoFornecedor },
    { path: '/arearestrita/habilitador/veracidade', component: VeracidadeFornecedor },
    { path: '/arearestrita/habilitador/consultar-solicitacao/:id', component: ConsultarFornecedor },
    { path: '/arearestrita/habilitador/consulta-cadastro', component: ConsultaCadastroFornecedor },
    { path: '/arearestrita/habilitador/dupla-conferencia', component: DuplaConferenciaFornecedor },

    //CADASTRADOR
    { path: '/arearestrita/cadastrador/solicitacao', component: Cadastrador },
    { path: '/arearestrita/cadastrador/cadastrar-solicitacao/:id', component: fornecedorForm },
    { path: '/extrato/:id', component: fornecedorExtrato },
    { path: '/documentos-vencidos', component: DocumentosVencidos },

    { path: '/resumo-habilitador/:id', component: ResumoHabilitador },
    { path: '/arearestrita/habilitador/dashboard', component: Dashboard },
    { path: '/arearestrita/habilitador/fornecedor-detalhe/:numCgcFornecedor', component: FornecedorDetalhe },
    { path: '/arearestrita/cadastrador/cadastrarnovo', component: CadastrarNovo },
    //Validador Master

    { path: '/relatorios', component: Relatorios },
 ]
